import { render, staticRenderFns } from "./OrticTable.vue?vue&type=template&id=527d4f7a&"
import script from "./OrticTable.vue?vue&type=script&lang=js&"
export * from "./OrticTable.vue?vue&type=script&lang=js&"
import style0 from "./OrticTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports